import { FC } from 'react';
import { HelixDialog } from '@projectaussie/component-library';
import { LifeStageCalculationModalContent } from 'projects/sharedComponents/src/geneticStats/lifeStage/lifeStagesCalculationModalContent';

type LifeStageCalculationModalProps = {
  open: boolean;
  onClose: () => void;
};

export const LifeStageCalculationModal: FC<LifeStageCalculationModalProps> = ({ open, onClose }) => {
  return (
    <HelixDialog open={open} onClose={onClose} maxWidth="sm" aria-labelledby="lifeStageCalculationModal-header">
      <LifeStageCalculationModalContent />
    </HelixDialog>
  );
};
